import { api_get_merchant_logs } from "../../../queries/merchants"
import { api_get_products_by_merchant_id_paginate, api_sync_with_treez, api_toggle_editors_pick } from "../../../queries/products"
import { toastToSuccess } from "../../../services/notification-service"

export const merchantProductsStoreActions = self => ({
    async getMerchantProductsPaginate(page, row) {
        try {

            self.set('loading', true)
            const res = await api_get_products_by_merchant_id_paginate(
                self.token, 
                page, 
                row, 
                self.merchantId, 
                self.searchString, 
                self.selectedCategoryId, 
                self.orderBy, 
                self.statuses,
                self.inStockOnly
            )

            if (res.error) throw res

            if (res.count !== 0) {
            self.set('allProducts', res.count)
            }
            const ids = await self.productsFactory.addUpdateProducts(res.rows)
            self.set('products', ids)
            self.set('loading', false)
            return res.data

        } catch (err) {
            self.set('loading', false)
            console.log(err)
        }
    },
    querrySearch(value) {
    self.set('currentPage', 1)
    self.set('searchInput', value)
    self.getMerchantProductsPaginate(self.currentPage, self.currentRow)
    },
    async checkIfCategoryExist(id, limit) {
        try {
            self.set('loading', true)
            const category = await self.categoriesFactory.getCategory(id)
            if (category.error) throw category
            self.set('loading', false)
            self.set('selectedCategory', category.id)
            self.getMerchantProductsPaginate(1, limit)
            return category
        } catch (err) {
            self.set('loading', false)
            console.log(err)
        }
      },
    async getMerchantLogs() {
        try {
            const res = await api_get_merchant_logs(self.token, self.merchantId)

            if (res.error) throw res

            self.set('merchantLogs', res.data)

            return res.data
        } catch (err) {
            return err
        }
    },
    setOrderBy(entity) {
        const orderTable = ["DESC", "ASC", null]

        const [currentEntity, currentDirection] = self.orderBy
            ? self.orderBy.split(",")
            : [null, null]

        // Switching to a different column starts a fresh cycle at DESC rather
        // than inheriting the previous column's position in the cycle.
        if (currentEntity !== entity) {
            self.set("orderBy", `${entity},DESC`)
            return
        }

        const currentIndex = orderTable.indexOf(currentDirection)
        const nextIndex = (currentIndex + 1) % orderTable.length
        const order = orderTable[nextIndex]

        if (!order) {
            self.set("orderBy", null)
            return
        }

        self.set("orderBy", `${entity},${order}`)
    },
    async toggleEditorsPick(product) {
        try {

            // first flip the switch
            product.set('isEditorsPick', !product.isEditorsPick)

            // call api to update
            const res = await api_toggle_editors_pick(self.token, product.id)
            if (res.error) throw res

            return res

        } catch (err) {
            // flip the switch back
            product.set('isEditorsPick', !product.isEditorsPick)
            return Error
        }
    },
    async syncWithTreez() {
        try {
            const res = await api_sync_with_treez(self.token, self.merchantId)
            if (res.error) throw res

            toastToSuccess({title: "Syncing with Treez. Refresh in a couple of seconds"})
            return res
        } catch (err) {
            throw err
        }
    },
    set(key, value) {
        self[key] = value
      }
})